"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "frisanco": {
    "38a468f3": [{
      "hkey": "d2a4d546",
      "slug": "polaz-cudili",
      "name": "Polaz-Cudili",
      "primary": true,
      "skipSearch": false
    }],
    "cudili": [{
      "hkey": "d2a4d546",
      "slug": "polaz-cudili",
      "name": "Polaz-Cudili",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "frisanco"
    }],
    "17322fb1": [{
      "hkey": "d28f3f6d",
      "slug": "fornasatte",
      "name": "Fornasatte",
      "primary": true,
      "skipSearch": false
    }],
    "fornasette": [{
      "hkey": "d28f3f6d",
      "slug": "fornasatte",
      "name": "Fornasatte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "97121164": [{
      "hkey": "d4892d21",
      "slug": "frisanco",
      "name": "Frisanco",
      "primary": true,
      "skipSearch": false
    }],
    "fulin": [{
      "hkey": "d4892d21",
      "slug": "frisanco",
      "name": "Frisanco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "35193a68": [{
      "hkey": "d4892d21",
      "slug": "frisanco",
      "name": "Frisanco",
      "primary": true,
      "skipSearch": false
    }],
    "pie-d-uviel": [{
      "hkey": "d4892d21",
      "slug": "frisanco",
      "name": "Frisanco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a8843e07": [{
      "hkey": "d2a4d546",
      "slug": "polaz-cudili",
      "name": "Polaz-Cudili",
      "primary": true,
      "skipSearch": false
    }],
    "polaz": [{
      "hkey": "d2a4d546",
      "slug": "polaz-cudili",
      "name": "Polaz-Cudili",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "12c5819d": [{
      "hkey": "d4892d21",
      "slug": "frisanco",
      "name": "Frisanco",
      "primary": true,
      "skipSearch": false
    }],
    "preplans": [{
      "hkey": "d4892d21",
      "slug": "frisanco",
      "name": "Frisanco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4966f226": [{
      "hkey": "17633683",
      "slug": "valdifrina",
      "name": "Valdifrina",
      "primary": true,
      "skipSearch": false
    }],
    "valdefrina": [{
      "hkey": "17633683",
      "slug": "valdifrina",
      "name": "Valdifrina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4beab700": [{
      "hkey": "d4892d21",
      "slug": "frisanco",
      "name": "Frisanco",
      "primary": true,
      "skipSearch": false
    }],
    "vallavan": [{
      "hkey": "d4892d21",
      "slug": "frisanco",
      "name": "Frisanco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;